export default {"interactive":"P0m3AW_interactive","card":"P0m3AW_card","frame":"P0m3AW_frame",}